package ru.villawonka.app.presentation.screens.searchFilter.compose.view

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxScope
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.windowInsetsPadding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import ru.villawonka.app.common.extensions.applyTelegramBottomInset
import ru.villawonka.app.getTelegram
import ru.villawonka.app.platform.platform.model.PlatformType
import ru.villawonka.app.presentation.design.components.AppButton
import ru.villawonka.app.presentation.design.components.AppButtonSize
import ru.villawonka.app.presentation.design.components.AppButtonType
import ru.villawonka.app.presentation.design.extensions.AppSpacer
import ru.villawonka.app.presentation.design.theme.surfaceMiddle
import ru.villawonka.app.presentation.screens.searchFilter.compose.SearchFilterCallbacks
import ru.villawonka.app.resources.AppResources

@Composable
fun BoxScope.ApplyButtonBlockView(
    platformType: PlatformType,
    callbacks: SearchFilterCallbacks
) {
    Box(
        modifier = Modifier
            .align(Alignment.BottomCenter)
            .background(
                color = MaterialTheme.colors.surfaceMiddle,
                shape = RoundedCornerShape(
                    topStart = 16.dp,
                    topEnd = 16.dp
                )
            )
            .fillMaxWidth()
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .applyTelegramBottomInset()
                .padding(16.dp)
        ) {
            if (platformType == PlatformType.TELEGRAM) {
                AppButton(
                    modifier = Modifier.weight(1f),
                    text = AppResources.strings.searchFilterBottomBarClear,
                    type = AppButtonType.TERTIARY,
                    size = AppButtonSize.MEDIUM,
                ) {
                    callbacks.onClearButtonClick()
                }
                AppSpacer(12.dp)
            }
            AppButton(
                modifier = Modifier.weight(1f),
                text = AppResources.strings.searchFilterBottomBarApply,
                type = AppButtonType.SECONDARY,
                size = AppButtonSize.MEDIUM,
            ) {
                callbacks.onApplyButtonClick()
            }
        }
    }
}